<template>
  <g>
    <rect class="border" :class="classRect"
          @click="consoleLog(name)"
          :x="x" :y="y" :rx="cellRadius"
          :width="cellWidth" :height="cellHeight"
          v-if="name"></rect>
    <text class="name" :x="x" :y="y" :dx="txtDx" :dy="txtDy" >{{ name }}</text>
  </g>
</template>

<script>
import { getShortName } from '../solfege'
import { CELL_WIDTH, CELL_HEIGHT, CELL_RADIUS } from '../grid'

export default {
  name: 'harmap-cell',

  props: ['x', 'y', 'pitch', 'type'],

  data () {
    return {
      cellWidth: CELL_WIDTH,
      cellHeight: CELL_HEIGHT,
      cellRadius: CELL_RADIUS,
      classRect: {
        '-over': this.type === 'over',
        '-trad': this.type === 'trad',
        '-natural': this.type === 'natural'
      }
    }
  },

  methods: {
    consoleLog (log) {
      console.log(log)
    }
  },

  computed: {
    name () { return this.pitch ? getShortName(this.pitch) : '' },
    txtDx () { return this.cellWidth / 2 },
    txtDy () { return this.cellHeight / 2 },
    isOverblow () { return this.type === 'over' },
    isTrad () { return this.type === 'trad' }
  }
}
</script>

<style scoped>
.border {
  stroke: black;
  stroke-width: 2px;
}
.name {
  font-size: 14px;
  text-anchor: middle;
  alignment-baseline: central;
}
.-natural{
  fill: lightgrey
}
.-over{
  fill: lightblue;
}
.-trad{
  fill: lightgreen;
}
</style>



// WEBPACK FOOTER //
// HarmapCell.vue?b59960b4